import { states_usa } from 'components/helper/state_usa';

/** Map a US state code (e.g. "CA") to its full name; return the input unchanged otherwise. */
const resolveStateName = (state: any): string => {
  if (state === undefined || state === null) return '';
  const match = states_usa.find((s: any) => s.value === state);
  return match ? match.name : String(state);
};

/** Normalize a field value for display: null/undefined → '', otherwise trimmed string. */
const toText = (value: any): string =>
  value === undefined || value === null ? '' : String(value).trim();

/**
 * Build the "(ceeb: ..., fib code: ..., state: ..., city: ..., country: ...)" meta line
 * shown under a college_board result (search suggestions and selected college).
 * All five labels are always printed, in a fixed order, even when a value is empty,
 * so every row has the same layout.
 */
export const formatCollegeMeta = (college: any): string => {
  const c = college || {};
  return (
    `(ceeb: ${toText(c.ceeb)}, fib code: ${toText(c.fib_code)}, ` +
    `state: ${resolveStateName(c.state)}, city: ${toText(c.city)}, country: ${toText(c.country)})`
  );
};
